/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
 import { __ } from '@wordpress/i18n';

 /**
  * React hook that is used to mark the block wrapper element.
  * It provides all the necessary props like the class name.
  *
  * @see https://developer.wordpress.org/block-editor/packages/packages-block-editor/#useBlockProps
  */
 import { useBlockProps, RichText, MediaPlaceholder, BlockControls, MediaUpload, URLInputButton, InspectorControls } from '@wordpress/block-editor';
 
 import { Placeholder, Toolbar, IconButton, PanelBody, PanelRow, ColorPicker, ColorPalette } from '@wordpress/components';
 import { get } from 'lodash';
 
 /**
  * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
  * Those files can contain any CSS code that gets applied to the editor.
  *
  * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
  */
 import './editor.scss';
 
 /**
  * The edit function describes the structure of your block in the context of the
  * editor. This represents what the editor will render when the block is used.
  *
  * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
  *
  * @return {WPElement} Element to render.
  */
 
 
 //
 // Media handling from https://samhermes.com/posts/implementing-media-controls-in-custom-blocks/
 //
 
 export default function edit(props) {
 
	 const { className, setAttributes } = props;
	 const { attributes } = props;
	 // let image;
 
	 function onSelectMedia( media ) {
		 // Try the "large" size URL, falling back to the "full" size URL below.
		 let src = get( media, [ 'sizes', 'large', 'url' ] ) || get( media, [ 'media_details', 'sizes', 'large', 'source_url' ] );
 
		 setAttributes( {
			 image: src || media.url,
		 } );
	 }
 
	 return (
		 <div { ...useBlockProps() }>
			 <BlockControls>
				 <Toolbar label="Tools">
					 <URLInputButton
						 url = { attributes.url }
						 onChange = { ( url, post ) => setAttributes( { url: url} ) }
					 />
					 <MediaUpload
						 onSelect = { onSelectMedia }
						 allowedTypes = { [ 'image' ] }
						 value = { attributes.image }
						 render = { ({ open }) => (
							 <IconButton
								 className="components-toolbar__control"
								 label = { __( 'Replace Image', 'museuio-companion' ) }
								 icon="format-image"
								 onClick = { open }
							 />
						 ) }
					 />
				 </Toolbar>
			 </BlockControls>
 
			 <div class="mio-logo-bar-item-block-fields">
				<RichText
					tagName="p" // The tag here is the element output and editable in the admin
					value={ attributes.title } // Any existing content, either from the database or an attribute default
					className="mio-logo-bar-item__title"
					allowedFormats={ [ 'core/italic' ] } // Allow the content to be made bold or italic, but do not allow other formatting options
					onChange={ ( content ) => setAttributes(  { title: content } ) } // Store updated content as a block attribute
					// placeholder={ __( 'Logo Bar Item Title' ) } // Display this text before any content has been added by the user
				/>

				{ !!attributes.image &&
					<div className="mio-logo-bar-item__image">
						<img src={ attributes.image } />
					</div>
				}
			 </div>
		 </div>
	 );
 }
 